import axios from 'axios'

// Cliente aislado: la instancia global de axios apunta a la API de Avanza con su
// Bearer, y no debe reutilizarse para hablar con el chatbot.
const api = axios.create({
  baseURL: process.env.VUE_APP_CHAT_API || 'http://127.0.0.1:8000',
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' }
})

const SESSION_STORAGE_KEY = 'avanza_chatbot_session_id'

export function getSessionId () {
  try {
    return localStorage.getItem(SESSION_STORAGE_KEY)
  } catch (e) {
    return null
  }
}

export function setSessionId (sessionId) {
  try {
    if (sessionId) localStorage.setItem(SESSION_STORAGE_KEY, sessionId)
  } catch (e) {
    // localStorage puede estar bloqueado (modo privado); la sesión vivirá en memoria
  }
}

export function clearSession () {
  try {
    localStorage.removeItem(SESSION_STORAGE_KEY)
  } catch (e) {
    // ignorar
  }
}

function errorMessage (error) {
  const detail = error.response && error.response.data && error.response.data.detail
  if (detail) return detail
  if (error.code === 'ECONNABORTED') return 'La consulta ha tardado demasiado. Inténtalo de nuevo.'
  if (!error.response) return 'No se ha podido conectar con el asistente. Revisa tu conexión.'
  return `Error ${error.response.status} al contactar con el asistente.`
}

export async function sendMessage (message, sessionId) {
  try {
    const { data } = await api.post('/api/chat', {
      message,
      session_id: sessionId || null
    })
    setSessionId(data.session_id)
    return {
      reply: data.reply || '',
      properties: data.properties || [],
      sessionId: data.session_id
    }
  } catch (error) {
    throw new Error(errorMessage(error))
  }
}

export async function health () {
  const { data } = await api.get('/api/health')
  return data
}

export default { sendMessage, getSessionId, setSessionId, clearSession, health }
